import React, { useState, useMemo, useEffect } from "react";
import "./SortBus.css";
import { RxCross2 } from "react-icons/rx";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { FiSunrise, FiSun, FiSunset, FiMoon } from "react-icons/fi";
import { MdEventSeat, MdAirlineSeatIndividualSuite } from "react-icons/md";

function SortBus({
  show,
  closeFilter,
  clearAllFilters,
  buses = [],
  priceLimits = [0, 0],
  onApplyFilters, 
}) {
  const [priceRange, setPriceRange] = useState(priceLimits);

  // ✅ keep priceRange in sync if priceLimits changes
  useEffect(() => {
    setPriceRange(priceLimits);
  }, [priceLimits]);

  // 🔹 States for Departure, Seat Type & Checkboxes
  const [selectedDeparture, setSelectedDeparture] = useState([]);
  const [selectedSeatType, setSelectedSeatType] = useState([]);
  const [selectedBusTypes, setSelectedBusTypes] = useState([]);
  const [selectedBoarding, setSelectedBoarding] = useState([]);
  const [selectedDropping, setSelectedDropping] = useState([]);
  const [selectedOperators, setSelectedOperators] = useState([]);

  // 🔹 Extract dynamic values from buses
  // Normalize BusType into AC / Non-AC
  const busTypes = useMemo(
    () =>
      [...new Set(
        buses.map((bus) =>
          bus.BusType?.toLowerCase().includes("a/c") ? "AC" : "Non-AC"
        )
      )],
    [buses]
  );

  const operators = useMemo(
    () => [...new Set(buses.map((bus) => bus.TravelName))],
    [buses]
  );
  const boardingPoints = useMemo(
    () =>
      buses.flatMap((bus) =>
        bus.BoardingPointsDetails?.map((bp) => bp.CityPointName) || []
      ),
    [buses]
  );
  const droppingPoints = useMemo(
    () =>
      buses.flatMap((bus) =>
        bus.DroppingPointsDetails?.map((dp) => dp.CityPointName) || []
      ),
    [buses]
  );

  // remove duplicates
  const uniqueBoarding = [...new Set(boardingPoints)];
  const uniqueDropping = [...new Set(droppingPoints)];

  // 🔹 Show/hide sections
  const [showBusType, setShowBusType] = useState(false);
  const [showAllBoarding, setShowAllBoarding] = useState(false);
  const [showAllDropping, setShowAllDropping] = useState(false);
  const [showAllOperators, setShowAllOperators] = useState(false);

  // 🔹 Toggle helpers
  const toggleDeparture = (slot) => {
    setSelectedDeparture((prev) =>
      prev.includes(slot) ? prev.filter((s) => s !== slot) : [...prev, slot]
    );
  };

  const toggleSeatType = (type) => {
    setSelectedSeatType((prev) =>
      prev.includes(type) ? prev.filter((s) => s !== type) : [...prev, type]
    );
  };

  const toggleCheckbox = (value, setter) => {
    setter((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const handleApply = () => {
    if (onApplyFilters) {
      onApplyFilters(
        priceRange,
        selectedBusTypes,
        selectedOperators,
        selectedBoarding,
        selectedDropping,
        selectedDeparture,
        selectedSeatType
      );
    }
    closeFilter();
  };


  return (
    <div className={`sortBus-custom-modal ${show ? "show" : ""}`}>
      <div className="sortBus-custom-overlay" onClick={closeFilter}></div>

      <div className="sortBus-custom-dialog">
        {show && (
          <div className="sortBus-close-icon" onClick={closeFilter}>
            <RxCross2 size={28} />
          </div>
        )}

        <div className="sortBus-filter-container">
          {/* Header */}
          <div className="sortBus-filter-header">
            <h5>Filter</h5>
            <span className="sortBus-reset-btn" onClick={clearAllFilters}>
              Reset
            </span>
          </div>

          {/* Departure Time */}
          <div className="sortBus-filter-section">
            <h6>Departure Time</h6>
            <div className="sortBus-option-group">
              {[
                { label: "Before 6AM", icon: <FiSunrise />, value: "before6" },
                { label: "6AM–12PM", icon: <FiSun />, value: "6to12" },
                { label: "12PM–6PM", icon: <FiSunset />, value: "12to6" },
                { label: "After 6PM", icon: <FiMoon />, value: "after6" },
              ].map((item) => (
                <div
                  key={item.value}
                  className={`sortBus-filter-option ${
                    selectedDeparture.includes(item.value) ? "active" : ""
                  }`}
                  onClick={() => toggleDeparture(item.value)}
                >
                  {item.icon} {item.label}
                </div>
              ))}
            </div>
          </div>

          {/* Seat Type */}
          <div className="sortBus-filter-section">
            <h6>Seat Type</h6>
            <div className="sortBus-option-group">
              {[
                {
                  label: "Sleeper",
                  icon: <MdAirlineSeatIndividualSuite />,
                  value: "sleeper",
                },
                { label: "Seater", icon: <MdEventSeat />, value: "seater" },
              ].map((item) => (
                <div
                  key={item.value}
                  className={`sortBus-filter-option ${
                    selectedSeatType.includes(item.value) ? "active" : ""
                  }`}
                  onClick={() => toggleSeatType(item.value)}
                >
                  {item.icon} {item.label}
                </div>
              ))}
            </div>
          </div>

{/* Bus Type */}
<div className="sortBus-filter-section">
  <h6>Bus Type</h6>
  <div className="sortBus-option-group">
    {busTypes.map((type) => (
      <div
        key={type}
        className={`sortBus-filter-option ${
          selectedBusTypes.includes(type) ? "active" : ""
        }`}
        onClick={() =>
          setSelectedBusTypes((prev) =>
            prev.includes(type)
              ? prev.filter((t) => t !== type)
              : [...prev, type]
          )
        }
      >
          <div className="sortBus-option-content">
            <img
              src={type === "AC" ? "/Images/buses/air-conditioner.png" : "/Images/buses/air-conditioning.png"}
              alt={type}
            />
            <span>{type}</span>
          </div>

      </div>
    ))}
  </div>
</div>


          {/* Price */}
          <div className="sortBus-filter-section">
            <h6>Price</h6>
            <Slider
              range
              min={priceLimits[0]}
              max={priceLimits[1]}
              value={priceRange}
              onChange={setPriceRange}
              trackStyle={[{ backgroundColor: "#007bff" }]}
              handleStyle={[
                { borderColor: "#007bff", backgroundColor: "#007bff" },
                { borderColor: "#007bff", backgroundColor: "#007bff" },
              ]}
            />
            <div className="sortBus-price-values">
              <span>₹ {priceRange[0]}</span>
              <span>₹ {priceRange[1]}</span>
            </div>
          </div>

          {/* Boarding Points */}
          <div className="sortBus-filter-section">
            <div className="sortBus-section-header">
              <h6>Boarding Points</h6>
              <span
                className="sortBus-show-more"
                onClick={() => setShowAllBoarding(!showAllBoarding)}
              >
                {showAllBoarding ? "Show Less" : "Show More"}
              </span>
            </div>
            {showAllBoarding && (
              <div className="sortBus-checkbox-list scrollable">
                {uniqueBoarding.map((point, index) => (
                  <label key={index} className="sortBus-checkbox-item">
                    <input
                      type="checkbox"
                      checked={selectedBoarding.includes(point)}
                      onChange={() => toggleCheckbox(point, setSelectedBoarding)}
                    />{" "}
                    {point}
                  </label>
                ))}
              </div>
            )}
          </div>

          {/* Dropping Points */}
          <div className="sortBus-filter-section">
            <div className="sortBus-section-header">
              <h6>Dropping Points</h6>
              <span
                className="sortBus-show-more"
                onClick={() => setShowAllDropping(!showAllDropping)}
              >
                {showAllDropping ? "Show Less" : "Show More"}
              </span>
            </div>
            {showAllDropping && (
              <div className="sortBus-checkbox-list scrollable">
                {uniqueDropping.map((point, index) => (
                  <label key={index} className="sortBus-checkbox-item">
                    <input
                      type="checkbox"
                      checked={selectedDropping.includes(point)}
                      onChange={() => toggleCheckbox(point, setSelectedDropping)}
                    />{" "}
                    {point}
                  </label>
                ))}
              </div>
            )}
          </div>

          {/* Operators */}
          <div className="sortBus-filter-section">
            <div className="sortBus-section-header">
              <h6>Bus Operator</h6>
              <span
                className="sortBus-show-more"
                onClick={() => setShowAllOperators(!showAllOperators)}
              >
                {showAllOperators ? "Show Less" : "Show More"}
              </span>
            </div>
            {showAllOperators && (
              <div className="sortBus-checkbox-list scrollable">
                {operators.map((op, index) => (
                  <label key={index} className="sortBus-checkbox-item">
                    <input
                      type="checkbox"
                      checked={selectedOperators.includes(op)}
                      onChange={() => toggleCheckbox(op, setSelectedOperators)}
                    />{" "}
                    {op}
                  </label>
                ))}
              </div>
            )}
          </div>
          
        </div>

        {/* Apply Button */}
        <div className="sortBus-apply-btn">
          <div className="sortBus-apply-btn">
          <button onClick={handleApply}>Apply</button>
        </div>
        </div>
      </div>
    </div>
  );
}

export default SortBus;
